import styled, { css } from 'styled-components';
import { Label as Label$1 } from '../label/label.component.js';
import { addsOpacity } from '../../utils/color-manipulation.js';
import 'react';

const error = (props) => props.error &&
    css `
    border: 1px solid
      ${props.checked ? 'transparent' : props.theme.colors.content.errorBright};
  `;
const disabled = (props) => props.disabled &&
    css `
    border: 1px solid
      ${addsOpacity({
        color: props.theme.colors.content.secondary,
        opacity: props.theme.opacities.low,
    })};
    cursor: not-allowed;
  `;
const hover = (props) => !props.disabled &&
    css `
    :hover {
      span {
        border: 1px solid
          ${props.error
        ? props.theme.colors.content.errorBright
        : props => props.theme.colors.background.primaryInverse};
      }
    }
  `;
const Input = styled.input `
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  cursor: inherit;
`;
const Checkmark = styled.span `
  align-self: flex-start;
  background-color: transparent;
  border-radius: ${props => props.theme.borderRadii.small};
  border: 1px solid
    ${props => props.checked ? 'transparent' : props.theme.colors.background.controls};
  box-sizing: content-box;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  margin: 3px 8px 0 0;
  min-width: 16px;
  position: relative;

  svg {
    vertical-align: top;
  }

  ${disabled}
  ${error}

  :focus-within {
    outline: transparent solid 2px;
    border: 1px solid
      ${props => props.error
    ? props.theme.colors.content.errorBright
    : props.theme.colors.background.primaryInverse};
    box-shadow: 0 0 0 1px
      ${props => props.theme.colors.background.primaryInverse} inset;
  }
`;
const Label = styled(Label$1).attrs({
    lineHeight: 'large',
}) `
  ${hover}
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export { Checkmark, Input, Label };
